import { useMutation } from 'react-query'
import { ChangePassword } from '../dtos'
import axios from 'axios'

const baseUrl = process.env.PUBLIC_URL
const apiUrl = process.env.REACT_APP_ACCOUNT_API
const url = `${baseUrl}/${apiUrl}`

export const useChangePassword = () => {
  return useMutation(
    (changePassword: ChangePassword) => axios.post(`${url}/ChangePassword`, changePassword),
    {},
  )
}

export const getResetPasswordUrl = (userId: string) =>
  `${url}/ResetPassword?userId=${userId}&returnUrl=${window.location.href}`

export const getLoginAsUrl = (asUserName: string, returnUrl: string) =>
  `${url}/Login?asUserName=${asUserName}&returnUrl=${returnUrl}`
